import { useContext, useEffect, useRef } from 'react'
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer'
import {Color, Entity, CallbackProperty, Cartesian3} from 'cesium';


interface Props {
    pos: number[];
    size: number;
}

function getColor(color: string | null) {
    if (color !== null) {
        return Color.fromCssColorString(color);
    }
    return Color.AQUA
}

export default function SolSymbol(props: Props) {
    const viewer = useContext(CesiumViewerContext)
    const entityRef = useRef<Entity>()
    useEffect(() => {
        if (!viewer) {
            return () => { }
        }
        const position = Cartesian3.fromDegrees(
            props.pos[0],
            props.pos[1],
            props.pos[2]
        );
        var colorStr = '#FF8800';
        //var colorStr = '#BBBBBB';
        //if(props.status.Array[0].Avail && props.status.Array[1].Avail && props.status.Array[0].Cal && props.status.Array[1].Cal) {
        //    colorStr = '#00FF00';
        //}
        //if(props.status.Array[0].Jammer || props.status.Array[1].Spoofer || props.status.Array[0].Jammer || props.status.Array[1].Spoofer) {
        //    colorStr = '#FF8800';
        //}
        const color = getColor(colorStr)
        const e = viewer.entities.add({
            position,
            point: {
                pixelSize: props.size,
                color,
            }
        } as any);
        entityRef.current = e;
        return () => { viewer!.entities.remove(e) }
    }, [viewer]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        const position = new CallbackProperty((time, result) => {
            return Cartesian3.fromDegrees(
                props.pos[0],
                props.pos[1],
                props.pos[2]
            )
        }, true) as any;
        entity!.position = position;
    }, [props.pos]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        (entity as any).point.pixelSize.setValue(props.size);
    }, [props.size])

    return null;
}
